module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 9);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("@sentry/types");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/toConsumableArray");

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = require("loglevel");

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/toArray");

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/slicedToArray");

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/classCallCheck");

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/createClass");

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/typeof");

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "createLogger", function() { return /* reexport */ createLogger; });
__webpack_require__.d(__webpack_exports__, "default", function() { return /* reexport */ loglevel_sentry_LoglevelSentry; });
__webpack_require__.d(__webpack_exports__, "redactData", function() { return /* reexport */ redactData; });

// EXTERNAL MODULE: external "loglevel"
var external_loglevel_ = __webpack_require__(3);
var external_loglevel_default = /*#__PURE__*/__webpack_require__.n(external_loglevel_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/toArray"
var toArray_ = __webpack_require__(4);
var toArray_default = /*#__PURE__*/__webpack_require__.n(toArray_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/toConsumableArray"
var toConsumableArray_ = __webpack_require__(2);
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/slicedToArray"
var slicedToArray_ = __webpack_require__(5);
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/classCallCheck"
var classCallCheck_ = __webpack_require__(6);
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/createClass"
var createClass_ = __webpack_require__(7);
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/defineProperty"
var defineProperty_ = __webpack_require__(1);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty_);

// EXTERNAL MODULE: external "@sentry/types"
var types_ = __webpack_require__(0);

// CONCATENATED MODULE: ./src/loglevel-sentry.ts







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



var loglevel_sentry_LoglevelSentry = /*#__PURE__*/function () {
  function LoglevelSentry(sentry) {
    classCallCheck_default()(this, LoglevelSentry);

    defineProperty_default()(this, "sentry", void 0);

    defineProperty_default()(this, "category", void 0);

    this.sentry = sentry;
    this.category = "loglevel-sentry";
  }

  createClass_default()(LoglevelSentry, [{
    key: "install",
    value: function install(logger) {
      var _this = this;

      var defaultMethodFactory = logger.methodFactory;

      logger.methodFactory = function (method, level, name) {
        if (name) _this.category = name.toString();
        var defaultMethod = defaultMethodFactory(method, level, name);

        switch (method) {
          case "error":
            return function () {
              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }

              var _LoglevelSentry$trans = LoglevelSentry.translateError(args),
                  _LoglevelSentry$trans2 = slicedToArray_default()(_LoglevelSentry$trans, 2),
                  err = _LoglevelSentry$trans2[0],
                  otherArgs = _LoglevelSentry$trans2[1];

              _this.error.apply(_this, [err].concat(toConsumableArray_default()(otherArgs)));

              if (defaultMethod) defaultMethod.apply(void 0, [err].concat(toConsumableArray_default()(otherArgs)));
            };

          default:
            return function () {
              for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = arguments[_key2];
              }

              _this.log.apply(_this, [LoglevelSentry.translateLevel(method)].concat(args));

              if (defaultMethod) defaultMethod.apply(void 0, args);
            };
        }
      };

      logger.setLevel(logger.getLevel());
    }
  }, {
    key: "setEnabled",
    value: function setEnabled(enabled) {
      this.sentry.getCurrentHub().getClient().getOptions().enabled = enabled;
    }
  }, {
    key: "isEnabled",
    value: function isEnabled() {
      return this.sentry.getCurrentHub().getClient().getOptions().enabled;
    }
  }, {
    key: "log",
    value: function log(level) {
      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }

      this.sentry.addBreadcrumb(_objectSpread(_objectSpread({}, LoglevelSentry.translateArgs(args)), {}, {
        category: this.category,
        level: level,
        timestamp: Date.now()
      }));
    }
  }, {
    key: "trace",
    value: function trace() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      this.log.apply(this, [types_["Severity"].Debug].concat(args));
    }
  }, {
    key: "error",
    value: function error(err) {
      for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        args[_key5 - 1] = arguments[_key5];
      }

      this.sentry.captureException(err, {
        tags: {
          logger: "loglevel-sentry",
          "logger.name": this.category
        },
        extra: {
          arguments: args
        }
      });
    }
  }], [{
    key: "translateError",
    value: function translateError(args) {
      // Find first Error or create an "unknown" Error to keep stack trace.
      var index = args.findIndex(function (arg) {
        return arg instanceof Error;
      });
      var err = index !== -1 ? args.splice(index, 1)[0] : new Error("unknown");
      return [err, args];
    }
  }, {
    key: "translateArgs",
    value: function translateArgs(args) {
      var _args = toArray_default()(args),
          firstArg = _args[0],
          otherArgs = _args.slice(1);

      return typeof firstArg === "string" ? {
        message: firstArg,
        data: {
          arguments: otherArgs
        }
      } : {
        data: {
          arguments: args
        }
      };
    }
  }, {
    key: "translateLevel",
    value: function translateLevel(level) {
      switch (level) {
        case "info":
          return types_["Severity"].Info;

        case "warn":
          return types_["Severity"].Warning;

        default:
          return types_["Severity"].Debug;
      }
    }
  }]);

  return LoglevelSentry;
}();


// CONCATENATED MODULE: ./src/create-logger.ts


function createLogger(name, sentry) {
  var logger = external_loglevel_default.a.getLogger(name);
  logger.enableAll();
  var plugin = new loglevel_sentry_LoglevelSentry(sentry);
  plugin.install(logger);
  return logger;
}
// EXTERNAL MODULE: external "@babel/runtime/helpers/typeof"
var typeof_ = __webpack_require__(8);
var typeof_default = /*#__PURE__*/__webpack_require__.n(typeof_);

// CONCATENATED MODULE: ./src/redact-data.ts

var defaultPattern = /(private|key|secret|authorization|address|email)+/i;
function redactData(data) {
  var keyPattern = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultPattern;
  if (typeof_default()(data) !== "object" || data === null) return data;
  var keys = Object.keys(data);

  for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
    var k = _keys[_i];
    var v = data[k];
    if (typeof v === "string" && keyPattern.test(k)) data[k] = "***";else data[k] = redactData(v, keyPattern);
  }

  return data;
}
// CONCATENATED MODULE: ./index.ts




/***/ })
/******/ ]);